import React from "react";
import HeaderCSS from "../../../style/helperCSS/HeadLine.module.css";

const HeadLine = (props) => {
  return (
    <div className={`${HeaderCSS.headline} ${props.className}`}>
      <div>
        <p className={`${HeaderCSS.typography}`}>{props.typography}</p>
      </div>
      <div className={`${HeaderCSS.headline_card}`}>
        <p className={`${HeaderCSS.title}`}>{props.title}</p>
        <div className={`${HeaderCSS.horizontal_line}`}></div>
      </div>
    </div>
  );
};

export default HeadLine;
